/**
 * Bandeau — une bande pleine largeur qui annonce un état (lot 5 du catalogue, 01-11-2026) :
 * « Mise à jour disponible », « Mode démo », « Ce fan est en pause », en haut d'un panneau ou de
 * la coque. C'est l'`Alerte` (mêmes tons, titre, texte, action, croix) étirée d'un bord à
 * l'autre, sans arrondi, une hairline dessous — à poser au-dessus du contenu, pas dedans.
 *
 *   <Bandeau ton="attention" texte="Une mise à jour est prête." action={<Button size="sm">Recharger</Button>} />
 *   <Bandeau ton="info" texte="Mode démo : rien ne part vraiment." onFermer={…} />
 */
import { Alerte, type AlerteProps } from "./Alerte";

export type BandeauProps = Omit<AlerteProps, "bande">;

export function Bandeau(props: BandeauProps) {
  return <Alerte {...props} bande />;
}
